import React, { useState, useEffect } from 'react';
import styles from './ModifyPositionModal.module.css';
import { FiTarget, FiShield } from 'react-icons/fi';

const ModifyPositionModal = ({ isOpen, onClose, position, onModify, livePrice }) => {
  const [targetPrice, setTargetPrice] = useState('');
  const [stoplossPrice, setStoplossPrice] = useState('');

  useEffect(() => {
    if (position) {
      setTargetPrice(position.targetPrice || '');
      setStoplossPrice(position.stoplossPrice || '');
    }
  }, [position]);

  if (!isOpen || !position) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onModify(position._id, { targetPrice, stoplossPrice });
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h3>Set Target & Stoploss</h3>
          <p>{position.tradeSymbol} • {position.quantity} Qty</p>
        </div>

        <div className={styles.priceInfo}>
          <div className={styles.priceItem}>
            <span>Entry Price</span>
            <span>₹{position.openPrice.toFixed(2)}</span>
          </div>
          <div className={styles.priceItem}>
            <span>LTP</span>
            <span className={styles.ltp}>₹{livePrice?.toFixed(2) || position.openPrice.toFixed(2)}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <div className={styles.inputLabel}>
              <FiTarget />
              <span>Target Price</span>
            </div>
            <input
              type="number"
              step="0.05"
              value={targetPrice}
              onChange={(e) => setTargetPrice(e.target.value)}
              placeholder="e.g. 150.00"
            />
          </div>

          <div className={styles.inputGroup}>
            <div className={styles.inputLabel}>
              <FiShield />
              <span>Stoploss Price</span>
            </div>
            <input
              type="number"
              step="0.05"
              value={stoplossPrice}
              onChange={(e) => setStoplossPrice(e.target.value)}
              placeholder="e.g. 90.00"
            />
          </div>

          <div className={styles.actions}>
            <button type="button" className={styles.btnCancel} onClick={onClose}>Cancel</button>
            <button type="submit" className={styles.btnConfirm}>Update Order</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModifyPositionModal;
